var _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4544_8834",
    x1: 35.2087,
    y1: 20.6411,
    x2: 11.7087,
    y2: 26.6411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE3285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A52293"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4544_8834",
    x1: 19,
    y1: 15,
    x2: 24.3688,
    y2: 21.5439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12F2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BBAC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4544_8834",
    x1: 24.8688,
    y1: 26.5439,
    x2: 19.8688,
    y2: 37.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BBAC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BDDE9"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5289 14.6797L15.0085 21.394L20.7188 21.394V19.9269L20.8324 19.8985C21.1771 19.8124 22.0622 19.6864 22.9769 19.5825C23.8932 19.4784 24.8593 19.394 25.3688 19.394C26.0387 19.394 26.4534 19.7722 26.7548 20.2089C26.8996 20.4188 27.0223 20.6479 27.1356 20.8595L27.1463 20.8795C27.25 21.073 27.3451 21.2487 27.4456 21.394L34.1477 21.394C33.5611 19.9959 31.8047 17.1796 28.8017 15.6781C28.0219 15.2882 26.952 15.0079 25.722 14.814C24.4941 14.6205 23.1163 14.5146 21.7264 14.4689C19.0225 14.38 16.2823 14.5191 14.5289 14.6797ZM25.7687 14.5177C27.0106 14.7134 28.1157 14.9997 28.9359 15.4098C32.1796 17.0317 34.0004 20.1344 34.5092 21.4913L34.5852 21.694L27.2938 21.694L27.2488 21.634C27.1157 21.4566 26.9978 21.2376 26.8819 21.0211L26.8743 21.0069C26.7587 20.7912 26.6429 20.575 26.5078 20.3792C26.2341 19.9826 25.8989 19.694 25.3688 19.694C24.8783 19.694 23.9277 19.7764 23.0107 19.8806C22.1848 19.9744 21.4024 20.0842 21.0188 20.1639V21.694L14.7291 21.694L14.2087 14.4085L14.3546 14.3946C16.1097 14.2275 18.9412 14.0771 21.7362 14.1691C23.1338 14.215 24.5247 14.3216 25.7687 14.5177Z",
    fill: "#8CF8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5359 10.0427C24.7076 9.76613 28.8563 10.8377 32.3708 13.097L41.5 12.5C43.2845 12.3253 43.5396 13.2901 43 15L38.022 31.8935C37.6937 32.9339 36.7287 33.6412 35.6378 33.6412H34.9795L33.3889 35.0035C30.6434 37.355 27.1185 38.5962 23.5053 38.4837L13.4552 38.1707C12.1055 38.1286 11.0331 37.0223 11.0331 35.6719V33.6412H7.50131C5.8657 33.6412 4.67066 32.0965 5.08143 30.5133L8.45441 17.5133C8.69969 16.568 9.46631 15.8673 10.398 15.6868L10.167 13.3129C10.0304 11.9087 11.0821 10.6696 12.4898 10.5763L20.5359 10.0427Z",
    fill: "#194777"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20874 30.1411L11.7087 18.6411L40.2087 16.1411L35.2087 30.1411H9.20874Z",
    fill: "url(#paint0_linear_4544_8834)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8091 21.1029L34.2671 23.4267L34.266 23.4267L34.2419 26.2366L33.7264 26.8513L32.8156 25.7266L31.9246 26.7889L31.848 26.7247L32.7572 25.6406L31.4882 23.0177L31.0155 26.7552L30.9163 26.7426L31.3947 22.9596L30.1165 23.9756L30.5551 26.7371L30.4564 26.7528L30.0632 24.2777L29.6346 26.7456L29.5361 26.7285L30.0102 23.9985L28.7475 23.9876L29.1746 26.7254L29.0758 26.7408L28.6863 24.2446L28.2541 26.7337L28.1555 26.7166L28.6383 23.9367L28.2034 21.1489L28.3022 21.1335L28.6442 23.3259L28.663 21.1447L28.763 21.1456L28.7394 23.8857L29.9859 23.8518L29.1256 21.1644L29.2208 21.1339L30.08 23.8177L31.3882 22.8353L30.0547 21.1885L30.1324 21.1256L31.3514 22.6308L30.9656 21.1778L31.0623 21.1521L31.4613 22.6553L31.8862 21.1592L31.9824 21.1865L31.5468 22.7203L33.8091 21.1029ZM31.5231 22.8603L32.798 25.4953L33.699 21.3045L31.5231 22.8603ZM33.7729 21.4365L32.9245 25.3823L34.1631 23.4164L33.7729 21.4365ZM34.1645 23.6018L32.8902 25.6244L34.1427 26.1436L34.1645 23.6018ZM34.1099 26.2383L32.9791 25.7696L33.7277 26.694L34.1099 26.2383Z",
    fill: "white",
    fillOpacity: 0.51
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1911 22.3988L16.0818 27.1913H15.5754V23.5456L15.1594 21.1499L15.258 21.1328L15.6254 23.249L15.9928 21.1328L16.0913 21.1499L15.7297 23.2328L16.831 21.1182L16.9197 21.1644L15.8418 23.2339L17.253 21.7099L17.6676 21.1128L17.7498 21.1698L17.3666 21.7216L18.492 22.2619V21.1413H18.592V22.2702L20.2587 21.6702V27.1413H20.1587V26.5669L19.4254 26.0389V27.1413H19.3254V26.2377L19.0059 27.1577L18.9115 27.1249L19.2887 26.0384L16.8188 27.2239L17.1911 22.3988ZM19.4307 25.9195L20.1587 26.4437V22.2502L19.4307 25.9195ZM20.091 21.8368L18.5814 22.3803L17.0719 26.7278L20.091 21.8368ZM16.955 26.7596L18.4801 22.3671L17.3363 21.818L16.955 26.7596ZM17.0075 27.0224L19.3312 25.9071L20.1057 22.0033L17.0075 27.0224ZM15.6754 24.4082V27.0913H15.9859L15.6754 24.4082ZM16.0585 26.8485L15.6777 23.5584L17.2009 21.9133L16.0585 26.8485Z",
    fill: "white",
    fillOpacity: 0.51
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3688 14.5439L14.8688 21.5439L20.8688 21.5439V20.0439C21.5354 19.8773 24.3688 19.5439 25.3688 19.5439C26.5688 19.5439 26.8688 20.8773 27.3688 21.5439L34.3688 21.5439C33.8688 20.2105 32.0688 17.1439 28.8688 15.5439C25.6688 13.9439 17.8688 14.2105 14.3688 14.5439Z",
    fill: "url(#paint1_linear_4544_8834)",
    stroke: "#8CF8FF",
    strokeWidth: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3688 26.5439H14.8688L15.3688 34.5439C17.3688 34.5439 23.0441 34.8007 25.8688 34.5439C30.2688 34.1439 33.7021 29.0439 34.8688 26.5439H28.3688L27.0682 28.1047C26.3082 29.0167 25.1824 29.5439 23.9953 29.5439H21.3688V26.5439Z",
    fill: "url(#paint2_linear_4544_8834)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7091 26.394H21.5188V29.394H23.9953C25.1379 29.394 26.2215 28.8865 26.9529 28.0088L28.2985 26.394H35.1043L35.0047 26.6075C34.4156 27.8698 33.257 29.7839 31.6901 31.4348C30.1252 33.0835 28.1351 34.4886 25.8824 34.6934C23.8284 34.8802 20.2696 34.7965 17.7114 34.7363C16.7409 34.7135 15.9144 34.694 15.3688 34.694H15.2279L14.7091 26.394ZM15.0284 26.694L15.5097 34.3944C16.0642 34.3973 16.8455 34.4156 17.7466 34.4368C20.3019 34.4969 23.8198 34.5797 25.8552 34.3947C28.0024 34.1995 29.929 32.8545 31.4725 31.2283C32.9277 29.695 34.0264 27.9283 34.6308 26.694H28.439L27.1834 28.2008C26.3949 29.147 25.2269 29.694 23.9953 29.694H21.2188V26.694H15.0284Z",
    fill: "#8CF8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevt);
export default __webpack_public_path__ + "static/media/devt.65b3bdc2347f9e6414430e839d7d2e9d.svg";
export { ForwardRef as ReactComponent };